import React, { useState } from 'react';
import { Button, List } from 'components/ds'
import { PlusOutlined, FilterOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { TextTitle, TextBig, ButtonSmall, PanelCard } from 'components/Css';
import TabsArrounds from '../../../../components/ds/custom/TabsArround';

const data1 = [
  {
    title: 'Mostre que conhece tudo sobre a campanha!',
    points: 100,
    daysLeft: 11,
    icon: <PlusOutlined />
  },
  {
    title: 'Mostre que conhece tudo sobre a campanha!',
    points: 100,
    daysLeft: 11,
    icon: <PlusOutlined />
  },
  {
    title: 'Mostre que conhece tudo sobre a campanha!',
    points: 100,
    daysLeft: 11,
    icon: <PlusOutlined />
  }
];

const data2 = [
  {
    title: 'Complete o desafio!',
    points: 200,
    daysLeft: 5,
    icon: <PlusOutlined />
  },
  {
    title: 'Complete o desafio!',
    points: 200,
    daysLeft: 5,
    icon: <PlusOutlined />
  },
  {
    title: 'Complete o desafio!',
    points: 200,
    daysLeft: 5,
    icon: <PlusOutlined />
  }
];

const MoreWrapper = styled.div`
  .ant-list-item {
    margin-bottom: 16px;
  }
  .load-more-button {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
`;

const QuizzesFilter = () => {
  const [items1, setItems1] = useState(data1);

  const [items2, setItems2] = useState(data2);

  const loadMoreItems1 = () => {
    const newItems = [
      ...items1,
      {
        title: 'Novo item adicionado',
        points: 100,
        daysLeft: 15,
        icon: <PlusOutlined />
      }
    ];

    setItems1(newItems);
  };

  const loadMoreItems2 = () => {
    const newItems = [
      ...items2,
      {
        title: 'Novo item adicionado',
        points: 200,
        daysLeft: 7,
        icon: <PlusOutlined />
      }
    ];

    setItems2(newItems);
  };

  const tabs = [
    {
      title: 'Próximos',
      content: (
        <MoreWrapper>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <TextBig>Exibindo 3 itens</TextBig>
            <ButtonSmall icon={<FilterOutlined />}>filtrar</ButtonSmall>
          </div>
          <List
            dataSource={items1}
            renderItem={(item: any) => (
              <List.Item>
                <PanelCard
                  title={`GANHE ${item.points} PONTOS`}
                  extra={item.icon}
                >
                  <p>{item.title}</p>
                  <p>{item.daysLeft} DIAS RESTANTES</p>
                  <Button>Responder</Button>
                </PanelCard>
              </List.Item>
            )}
          />
          <div className="load-more-button">
            <Button onClick={loadMoreItems1}>
              Carregar Mais
            </Button>
          </div>
        </MoreWrapper>
      )
    },
    {
      title: 'Encerrados',
      content: (
        <MoreWrapper>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <TextBig>Exibindo 3 itens</TextBig>
            <ButtonSmall icon={<FilterOutlined />}>filtrar</ButtonSmall>
          </div>
          <List
            dataSource={items2}
            renderItem={(item: any) => (
              <List.Item>
                <PanelCard
                  title={`GANHE ${item.points} PONTOS`}
                  extra={item.icon}
                >
                  <p>{item.title}</p>
                  <p>{item.daysLeft} DIAS RESTANTES</p>
                  <Button >Responder</Button>
                </PanelCard>
              </List.Item>
            )}
          />
          <div className="load-more-button">
            <Button onClick={loadMoreItems2}>
              Carregar Mais
            </Button>
          </div>
        </MoreWrapper>
      )
    }
  ];

  return <>
    <TextTitle style={{ marginBottom: '20px' }}>Fique ligado nas datas dos sorteiros, você já está concorrendo!</TextTitle>
    <TabsArrounds tabs={tabs} />;
  </>
};

export default QuizzesFilter;
